module.exports = __webpack_public_path__ + "img/stamp_phone.71a06d06.svg";